import Layout from "../components/layout"
import Link from "gatsby-plugin-transition-link"
import AniLink from "gatsby-plugin-transition-link/AniLink";
import React from "react"
import SEO from "../components/seo"
import Helmet  from "react-helmet"
import Quote from "../components/Quote"
import JoinCommunity from "../components/JoinCommunityRow"
import Truncate from "react-truncate"
import styles from "../styles/blog.module.scss"
import NewstellerForm from "../components/NewstellerForm"
import Button from "@material-ui/core/Button"




const BlogPage = ({ data, pageContext }) => {
  //More Pagination Setup

  const { edges: posts } = data.allWpPost
  return (
    <Layout>
       <Helmet>
       <title>Journal | em•power with Shawna | More Than a Fitness Blog</title>
       <meta name="title" content="Journal" />
            <meta name="description" content="We all have a story to tell! Read some advice on health and wellness and success stories from our fitness and meditation program." />   
             </Helmet>
      <div className={styles.blog}>
        <div className={styles.blog_left}>
          <h1 className={styles.page_title}>When we remember that we all have a story, we are kinder to one another.</h1>
          <p className={styles.page_content}>Every choice we’ve ever made has led us to where we are today. We all
            have stories to tell, and while some stories can hold us back, others
            can move us forward and inspire others along the way. Here on our
            fitness blog, we post real stories of real women. Our community health
            goals come from embracing our own success stories while supporting those
            of the people around you. We will update our community with real stories
            of our clients here on the blog.
          </p>

          <p className={styles.form_headline}>
            Join the <strong>em•</strong>powered community
          </p>
          <div className={styles.form}>
            <NewstellerForm />
          </div>
        </div>
        <div className={styles.blog_right}>
          <div className={styles.blog_archive}>
            {/*Maps over each individual post to display in blog */}
            {posts.map(({ node: post }, index) => (
              <div
                key={post.slug}
                className={styles.blog_item}
                style={{ marginBottom: 50 }}
              >
                {/* <img
                  className={styles.blog_img}
                  src={post.featuredImage.node.sourceUrl}
                  alt={post.featuredImage.node.altText}
                /> */}

                <h3 className={styles.blog_title}>{post.title}</h3>
                <Truncate lines={3}>
                  <div
                    className={styles.blog_content}
                    // dangerouslySetInnerHTML={{ __html: post.excerpt }}
                  >
                    {post.excerpt.replace(/(<([^>]+)>)/gi, "")}
                  </div>
                </Truncate>
                <p className={styles.blog_date}>{post.date}</p>
                <AniLink
                  paintDrip
                  to={post.uri}
                  direction="right"
                  hex="#9FE5E3"
                  className={styles.readmore}
                  duration={0.7}>
                  Read More...
                </AniLink>
              </div>
            ))}
          </div>
         
        </div>
      </div>

      <Quote
        quote={"To know who you are is critical to this world."}
        personName={"- shawna"}
      />

      <JoinCommunity />

    </Layout>
  )
}
export default BlogPage

export const pageQuery = graphql`
  query IndexQuery {
    allWpPost(sort: { fields: [date] }) {
      edges {
        node {
          title
          excerpt
          id
          slug
          link
          uri
          date(formatString: "MMMM DD, YYYY")
          featuredImage {
            node {
              sourceUrl
              altText
            }
          }
        }
      }
    }
  }
`
